import { _ } from "@sablier/v2-mixins";
import { createWalletClient, http } from "viem";
import { privateKeyToAccount } from "viem/accounts";
import { goerli } from "viem/chains";
import { MockConnector } from "wagmi/connectors/mock";
import type { IEnvironmentVariable, IWagmiAddress } from "@sablier/v2-types";

function account() {
  const secret: IEnvironmentVariable = process.env.NEXT_PUBLIC_TEST_PRIVATE_KEY;

  if (_.isNilOrEmptyString(secret)) {
    throw new Error(
      "Missing environment variable: NEXT_PUBLIC_TEST_PRIVATE_KEY",
    );
  }

  const key = secret.startsWith("0x") ? secret : `0x${secret}`;
  return privateKeyToAccount(key as IWagmiAddress);
}

function getClient() {
  return createWalletClient({
    key: "MockWallet",
    name: "Mock Wallet",
    account: account(),
    chain: goerli,
    transport: http(),
  });
}

const connector = () => [
  new MockConnector({
    options: {
      walletClient: getClient(),
      chainId: goerli.id,
    },
  }),
];

export { connector };
